const sortByType = (a, b) => {
  if (a.value.type === b.value.type)
    return 0;
  if (a.value.type > b.value.type)
    return -1;
  return 1;
};
const sortByName = (a, b) => a.label.localeCompare(b.label);
export {
  sortByName,
  sortByType
};
